import * as ScrollUtil from '../utils/scrolling';

/**
 * Form component
 *
 * Funktionen für Formulare.
 */

/**
 * Eine input-active Klasse wird hinzugefügt, sobald ein Input-Feld fokussiert
 * wird oder einen Wert hat.
 *
 * @param {string} selector
 */
function steerLabels(selector = '.widget-text input, .widget-textarea textarea') {
    document.querySelectorAll(selector).forEach((input) => {
        // Remove active class from label on blur if input is empty
        input.addEventListener('blur', function () {
            if (this.value === '') {
                this.parentNode.querySelector('label').classList.remove('input-active');
            }
        });

        // Add active class to label on focus
        input.addEventListener('focus', function () {
            this.parentNode.querySelector('label').classList.add('input-active');
        });

        // Add active class to label on page load if input is not empty
        if (input.value !== '') {
            input.parentNode?.querySelector('label')?.classList.add('input-active');
        }
    });
}

/**
 * Wenn Formular-Fehler auf der Seite sind, wird automatisch zum ersten gescrollt
 */
function scrollToErrors() {
    const firstError = document.querySelector('.error');

    ScrollUtil.scrollToTarget(firstError, -15);
}

$(function () {
    scrollToErrors();
    steerLabels();
});
